import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, orderBy, has } from 'lodash';
import moment from 'moment';
import { Link } from '@bd/bdcore-named-routes';
import { css, cx } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { BtnAnimationSheen } from '../../helpers/UIElements';
import { colors, typography } from '../../styles';

const styles = css`
  font-family: ${typography.objektiv};
  background-color:#FFF;
  .PostBody_image {
    display: block;
    width: 100%;
    height: 240px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    @media(min-width: 768px) {
      height: 400px;
    }
    @media(min-width: 992px) {
      height: 531px;
    }
  }
  .MainWrapperWidth {
    @media(min-width: 992px){
      max-width: 64% !important;
    }
  }
  .PostBody_date {
    font-weight: 300;
    font-size: 13px;
    color: ${colors.color5};
    line-height: 28px;
    margin: 8px 0 1px 0;
    @media(min-width: 992px) {
      font-weight: 300;
      font-size: 17px;
      line-height: 24px;
      margin: 27px 0 0 0;
    }
  }
  .PostBody_title {
    position: relative;
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    color: ${colors.color3};
    margin-top: 8px;
    margin-bottom: 55px;
    @media(min-width: 992px) {
      font-size: 37px;
      line-height: 50px;
      margin-bottom: 61px;
    }
    &:after {
      content: '';
      height: 2px;
      width: 75px;
      background-color: ${colors.color1};
      position: absolute;
      bottom: -30px;
      left: 0;
      @media(min-width:992px) {
        width: 100px;
        bottom: -31px;
      }
    }
  }
  .blog_sidebarWrapper{
    background-color: ${colors.bg};
    padding: 37px 44px 55px 32px;
    height: 750px;
  }
  .blog_sidebarHeading {
    font-weight: 800;
    color: ${colors.color3};
    text-transform: uppercase;
    font-size: 22px;
    letter-spacing: 3px;
    line-height: 30px;
    margin-bottom: 22px;
    position: relative;
  }
  .BlogPost_date {
    color: ${colors.text} !important;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
  }
  .Blogposts_title {
    color: ${colors.color1};
    font-weight: bold;
    font-size: 17px;
    line-height: 24px;
    margin-bottom: 22px;
    &:hover {
      color: ${colors.color1Lightest};
    }
  }
  .Blogposts_latest {
    padding-top: 40px;
    background-color: #F6F6F6;
    @media(min-width: 576px) {
      padding: 60px;
    }
    @media(min-width: 992px) {
      background-color: transparent;
      max-width: 31% !important;
      padding: 40px;
      height: 100%;
    }
  }
  .PostBody_body {
    color: ${colors.text};
    font-weight: 300;
    font-size: 15px;
    line-height: 28px;
    @media(min-width:992px) {
      padding-bottom: 10px;
      font-size: 17px;
      line-height: 30px;
    }
    img {
      width: 100%;
      @media(min-width: 992px) {
        /* max-width: 500px; */
      }
    }
    p:first-of-type {
      font-weight: 300;
      font-size: 18px;
      line-height: 32px;
      color: ${colors.black};
      @media(min-width: 992px) {
        font-size: 21px;
        line-height: 40px;
      }
    }
  }

    .PostBody_body ul {
    padding-left: 0;
    padding-right: 2rem;
    list-style: none;
    }
    .PostBody_body ul li {
      text-align: left;
      width: 100%;
      position: relative;
      font-weight: 300;
      font-size: 16px;
      line-height: 28px;
      padding: 0px 0px 20px;
      margin: 0px 0px 0px 30px;
    }
    .PostBody_body ul li::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: rgb(128,128,128);
    position: absolute;
    left: -30px;
    top: 9px;
    }

  .Blogpost_tags {
    border-top: solid 1px #d4d4d4;
    padding-top: 20px;
    font-size: 15px;
    display: flex;
    .Blog_tagList {
      list-style: none;
      padding: 0 0 0 5px;
      display: flex;
      flex-wrap: wrap;
      font-weight: 700;
      color: #212121;
      letter-spacing: 0;
      li {
        margin-right: 10px;
        position: relative;
        &::after {
          content: ', ';
        }
        &:last-child {
          &::after {
            content: none;
          }
        }
      }
    }
  }
}

  .Blogpost_other {
    margin: 25px 5px;
    @media(min-width: 320px){
      margin: 25px 5px;
    }
    @media(min-width: 576px){
      margin: 25px 15px;
    }
    @media(min-width: 768px){
      margin: 35px 15px;
    }
    @media(min-width: 992px) {
      margin: 54px 10px;
    }
  }
  .Blogpost_otherLink {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 12px 20px 11px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.12px;
    line-height: 22px;
    text-transform: capitalize;
    color: white;
    background-color: ${colors.color1};
    cursor: pointer;
    &:focus {
      outline: none;
    }
    @media (min-width: 320px) {
      padding: 12px 25px 11px;
    }
    @media(min-width: 576px){
      padding: 15px 35px 14px;
    }
    @media (min-width: 992px) {
      padding: 15px 56px 14px;
      font-size: 17px;
      line-height: 24px;
      transition: background-color 350ms ease;
    }
  }
  .Blogpost_previous {
    margin-right: 0px;
  }

`;

function PostBody({ blogpost, className, blogposts }) {
  const blogImageSrc = get(blogpost, 'logo.contentUrl');
  const postDate = get(blogpost, 'date');
  const postBody = get(blogpost, 'htmlbody');
  const latestPosts = blogposts.filter(item => item._id !== get(blogpost, '_id'));

  let previous = null;
  let next = null;

  const posts = orderBy(blogposts, 'date', 'desc');
  const index = posts.indexOf(blogpost);

  if (index === 0) {
    previous = null;
    next = posts[index + 1];
  }

  if (index > 0) {
    previous = posts[index - 1];
    next = posts[index + 1];
  }
  if (index === posts.length - 1) {
    previous = posts[index - 1];
    next = null;
  }

  return (
    <article className={`${cx(styles, className)}`}>
      <PageHelmet blogpost={blogpost} />
      <div className="container-fluid" >
        <div className="row">
          <div className="col-12 col-lg-4 order-2 ml-lg-4 blog_sidebarWrapper d-none d-lg-block">
            <h3 className="blog_sidebarHeading">Latest Posts</h3>
            {
            orderBy(latestPosts, 'date', 'desc').slice(0, 6).map(post => (
              <Link className="SidebarPost_wrapper" name="blogpost-detail" params={{ blogpostTitle: post.title }} key={post._id}>
                <p className="BlogPost_date">
                  {
                    has(post, 'date') &&
                    moment(get(post, 'date')).format('MMMM D, YYYY')
                  }
                </p>
                <h4 className="Blogposts_title">{post.title}</h4>
              </Link>
            ))
            }
          </div>
          <div className="col-12 col-lg order-1 px-0 MainWrapperWidth">
            {
              blogImageSrc &&
              <div
                className="PostBody_image"
                style={{ backgroundImage: `url('${buildThumbnailUrl(get(blogpost, 'logo.contentUrl'), { width: 800, height: 800 })}')` }}
              />
            }
            <div className="PostBody_content position-relative">
              {
                postDate &&
                <div className="PostBody_date">
                  {moment(postDate).format('MMMM D, YYYY')}
                </div>
              }
              {
                postBody &&
                <div>
                  <h2 className="PostBody_title">{get(blogpost, 'title')}</h2>
                </div>
              }
              {
                postBody &&
                <div className="PostBody_body" dangerouslySetInnerHTML={SanitizeHtml(postBody)} />
              }
            </div>
          </div>
          <div className="col-lg-12 order-3">
            <div className="d-flex flex-row justify-content-center">
              <div className="Blogpost_other">
                {
                  previous !== null &&
                  <div>
                    <Link
                      name="blogpost-detail"
                      params={{ blogpostTitle: get(previous, 'title') }}
                    >
                      <BtnAnimationSheen className="Blogpost_otherLink Blogpost_previous">
                        Prev Post
                      </BtnAnimationSheen>
                    </Link>
                  </div>
                }
              </div>
              <div className="Blogpost_other">
                {
                  next !== null &&
                  <div>
                    <Link name="blogpost-detail" params={{ blogpostTitle: get(next, 'title') }}>
                      <BtnAnimationSheen className="Blogpost_otherLink d-flex">Next Post</BtnAnimationSheen>
                    </Link>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

PostBody.propTypes = {
  blogpost: PropTypes.object.isRequired,
  className: PropTypes.string,
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

PostBody.defaultProps = {
  className: '',
};

export default withData(
  {
    blogpost: true,
    blogposts: true,
  },
)(PostBody);



// WEBPACK FOOTER //
// ./src/pages/BlogpostDetail/PostBody.js